import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getRejectReasonsService, createRejectReasonsService, updateRejectReasonsService } from "_services/timeline-service";

const initialState = {
    reasons: [],
    status: "idle",
    error: null,
    isStaticReasons: true
}

export const getRejectReasons = createAsyncThunk(
    "rejectReasons/getRejectReasonsService",
    async (params) => {
        return getRejectReasonsService(params);
    }
);

export const createRejectReasons = createAsyncThunk(
    "rejectReasons/createRejectReasons",
    async (params) => {
        return createRejectReasonsService(params);
    }
);

export const updateRejectReasons = createAsyncThunk(
    "rejectReasons/updateRejectReasons",
    async (params) => {
        return updateRejectReasonsService(params);
    }
);

const rejectReasonssSlice = createSlice({
    name: "rejectReasons",
    initialState,
    reducers: {
        reset: (state) => initialState,
        resetStatus: (state) => {
            state.status = "idle";
        },
    },
    extraReducers: {
        [getRejectReasons.pending]: (state, action) => {
            state.status = "loading";
        },
        [getRejectReasons.fulfilled]: (state, action) => {
            state.status = "succeeded";
            state.reasons = action.payload.reasons || [];
            state.isStaticReasons = action.payload.isStaticReasons || false;
        },
        [getRejectReasons.rejected]: (state, action) => {
            state.status = "failed";
            state.error = action.error.message;
        },
        [createRejectReasons.pending]: (state, action) => {
            state.status = "loading";
        },
        [createRejectReasons.fulfilled]: (state, action) => {
            state.status = "succeeded";
        },
        [createRejectReasons.rejected]: (state, action) => {
            state.status = "failed";
            state.error = action.error.message;
        },
        [updateRejectReasons.pending]: (state, action) => {
            state.status = "loading";
        },
        [updateRejectReasons.fulfilled]: (state, action) => {
            state.status = "succeeded";
        },
        [updateRejectReasons.rejected]: (state, action) => {
            state.status = "failed";
            state.error = action.error.message;
        },

    }
})

export const { resetStatus, reset } = rejectReasonssSlice.actions;

export const selectRejectReasonsByType = (state, type = "ALL") => {
    if (type === "ALL") return state.rejectReasons.reasons;
    const targetReasons = state.rejectReasons.reasons.filter(reason => reason.eligible.includes(type))

    return targetReasons
}
export const selectRejectReasonsStatus = state => state.rejectReasons.status;
export const checkIfStaticReasons = state => state.rejectReasons.isStaticReasons

export default rejectReasonssSlice.reducer;
